import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDtPVpSK49_lok_8k3b-8f6oOSL5XUvDNQ",
  authDomain: "loops-a75af.firebaseapp.com",
  projectId: "loops-a75af",
  storageBucket: "loops-a75af.firebasestorage.app",
  messagingSenderId: "590029235473",
  appId: "1:590029235473:web:eb7ba50f819f4cf877d8b0",
  measurementId: "G-P9BFN69M17",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Create Google Auth Provider
const googleProvider = new GoogleAuthProvider();

// Configure Google provider to always show account selection
googleProvider.setCustomParameters({
  prompt: "select_account",
});

export {
  auth,
  googleProvider,
  signInWithPopup,
};
